.fp-dynamic-grid--tile(:style='`width: ${cardPxSize}px; height: ${cardPxSize}px;`')
  slot
